export default __webpack_public_path__ + "static/media/stortplaats.ed26a75e.svg";